import './AdminNavbar.scss';

import { useState } from 'react';
import ReactModal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { impersonateUser, loadUser } from 'actions/user';
import Icon from 'atoms/icon';
import ProviderSearch from 'organisms/ProviderSearch';
import { clearImpersonation } from 'store/reducers/impersonation';
import { userSetCredentials } from 'store/reducers/user';

import AdminButton from './AdminButton';

function AdminNavbar() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { uuid: adminUuid, token: adminToken } = useSelector(
    (state) => state.adminUser
  );
  const { uuid: currentUserUuid, providerUsers: userProviders } = useSelector(
    (state) => state.user
  );
  const { userList: providerUsers, uuid: providerUuid } = useSelector(
    (state) => state.otherProvider
  );
  const [isOpen, openSearchModal] = useState(false);
  const providerUserId = providerUsers?.[0]?.user?.uuid;
  const isMyProvider = userProviders?.provider?.uuid === providerUuid;
  // You can impersonate a provider if it has a user associated with it,
  // and it's not your own provider
  const canImpersonate = providerUserId && !isMyProvider;
  const isImpersonating = adminUuid && adminUuid !== currentUserUuid;

  const setState = (state) => {
    if (state) {
      dispatch(impersonateUser(providerUserId));
    } else {
      dispatch(userSetCredentials({ token: adminToken, uuid: adminUuid }));
      dispatch(loadUser(adminUuid));
      navigate('/services');
    }
  };

  if (!adminUuid || location.pathname === '/') return null;

  return (
    <>
      <div className="admin-navbar flex-row">
        <AdminButton
          setState={setState}
          canImpersonate={canImpersonate}
          isImpersonating={isImpersonating}
        />
        {!isImpersonating && (
          <button
            className="search-button pointer admin-nav-button"
            onClick={() => openSearchModal(true)}
          >
            <Icon name="search" style={{ fill: 'white' }} />
          </button>
        )}
      </div>
      <ReactModal
        ariaHideApp={false}
        isOpen={isOpen}
        onRequestClose={() => openSearchModal(false)}
      >
        <ProviderSearch />
      </ReactModal>
    </>
  );
}

export default AdminNavbar;
